import { useState } from 'react';

import { So5LeaderboardSeasonality } from '@sorare/core/src/__generated__/globalTypes';
import { useConversionCredits } from '@sorare/core/src/hooks/useConversionCredits';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';
import { ClickInstantBuy_Flow } from '@sorare/core/src/protos/events/so5/shared/events';

import {
  PlayerDrawer,
  Props as PlayerDrawerProps,
} from 'components/player/PlayerDrawer';
import { PlayerMarketDrawer } from 'components/player/PlayerMarketDrawer';
import { Pagination } from 'searchCards/Pagination';
import { PlayerResultsProps } from 'searchCommonPlayer/AdvancedPlayerSearch/types';
import { useManagePlayerSearchView } from 'searchCommonPlayer/StatsManager/useManagePlayerSearchView';

import { SearchBenchObjectTable } from '../SearchBenchObjectTable';

export const PaginatedPlayerRows = (props: PlayerResultsProps) => {
  const { PlayerDetailsComponent, sport } = props;
  const { statsManager } = useManagePlayerSearchView();
  const [cardOpened, setCardOpened] =
    useState<PlayerDrawerProps['cardOpened']>(null);
  const [marketPlayerSlug, setMarketPlayerSlug] = useState<string | null>(null);

  const { conversionCredits } = useConversionCredits({
    sport,
  });
  const canUseConversionCredit = conversionCredits?.some(cc => !cc.disabled);

  return (
    <>
      <SearchBenchObjectTable
        {...props}
        onStatsClick={playerSlug =>
          setCardOpened({
            cardSlug: '',
            playerSlug,
          })
        }
        onListingsClick={playerSlug => setMarketPlayerSlug(playerSlug)}
      />
      <Pagination visible />
      <PlayerDrawer
        cardOpened={cardOpened}
        onClose={() => {
          setCardOpened(null);
        }}
        PlayerDetails={PlayerDetailsComponent}
        withBuyingOptions={{
          rarity: statsManager[PlayerSearchViewAttributes.RARITY],
          inSeason:
            statsManager[PlayerSearchViewAttributes.SEASONALITY] ===
            So5LeaderboardSeasonality.IN_SEASON,
          onMarketClick: slug => setMarketPlayerSlug(slug),
        }}
      />
      <PlayerMarketDrawer
        onClose={() => setMarketPlayerSlug(null)}
        playerSlug={marketPlayerSlug}
        canUseConversionCredit={canUseConversionCredit}
        clickInstantBuyFlow={ClickInstantBuy_Flow.SCOUTING_CENTER}
      />
    </>
  );
};
